import React, { useEffect } from 'react';
import PageWrapper from 'components/Common/PageWraper';
import { powerBIdashboardUrl } from '../../service/config';
import Box from '@mui/material/Box';
import AnalyticsVisualization from '../framework/analyticsVisualization';
import PageHeader from 'components/Header/Page';
import BIApplicationIcon from '../../assets/biApplication.svg';

const BAICenter = () => {
  useEffect(() => {
    const activeId = document.getElementById('root');
    console.log(window.location.pathname);
    if (window.location.pathname.includes('/D&AIXOps')) {
      if (activeId) {
        document.head.classList.add('theme-bg-blue');
        document.body.classList.add('theme-bg-blue');
      }
    }
  }, []);

  return (
    <PageWrapper>
      <PageHeader title="Business Application Intelligence Center" icon={BIApplicationIcon}> </PageHeader>
        <AnalyticsVisualization
          params={{
            dashboardUrl: powerBIdashboardUrl.BAICenterDashboard,
            className: 'powerBiIframeContainer',
            otherParams: {
              name: 'PowerBI',
            },
            seamless: true,
          }}
        />
    </PageWrapper>
  );
};

export default BAICenter;
